import { render, staticRenderFns } from "./WebhooksSettings.vue?vue&type=template&id=8f6aeb56&"
import script from "./WebhooksSettings.vue?vue&type=script&lang=js&"
export * from "./WebhooksSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports